export const styles = () => ({
  root: {
    width: "1000px",
    height: "700px",
    background: "#FFFFFF",
    boxShadow: "8px 8px 24px rgba(0, 0, 0, 0.1)",
    maxWidth: "1000px",
  },
  headerRoot: {
    padding: 32,
    marginTop: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  customHeaderRoot: {
    padding: "32px 32px 16px 32px",
    marginTop: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "right",
  },
  closeButton: {
    cursor: "pointer",
    "&:hover path": {
      stroke: "#26bbed",
    },
  },
  headerLeft: {
    fontFamily: "Open Sans",
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: "30px",
    paddingTop: "8px",
    paddingBottom: "8px",
    paddingLeft: "16px",
    display: "flex",
    alignItems: "center"
  },
  logoClass: {
    paddingRight: 12,
  },
  introLogoClass: {
    paddingRight: 12,
    height: 50,
    width: 50,
  },
  container: {
    padding: 0,
  },
  dialogAction: {
    padding: "40px 0px 28px 0px !important",
    justifyContent: "center",
  },
  arrow: {
    height: 32,
    width: 32,
    background: "#F9F9F9",
    borderRadius: "16px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0px 14px",
    "&:hover path": {
      stroke: "#26bbed",
    },
  },
  forwardArrow: {
    transform: "rotate(180deg)",
  },
  visibility: {
    visibility: "hidden",
  },
  circle: {
    margin: "0px 16px",
    height: 12,
    width: 12,
    borderRadius: "6px",
    background: "#26bbed",
    opacity: "0.2",
    transition: "opacity 0.6s ease",
    cursor: "pointer",
    "&:hover": {
      opacity: "0.7",
    },
  },
  active: {
    opacity: 1,
  },
  slideContent: {
    display: "flex",
    justifyContent: "center",
    transitionTimingFunction: "linear",
    padding: "20px 0px 0px 48px",
  },
  leftContainer: {
    paddingRight: 48,
    paddingTop: 77,
  },
  image: {
    width: 600,
    height: 460,
    border: "1px solid #EEEEEE",
    boxShadow: "-5px 0px 30px rgba(0, 0, 0, 0.05)",
    borderRadius: "10px 0px 0px 10px",
  },
  step: {
    fontFamily: "Open Sans",
    fontSize: "12px",
    lineHeight: "18px",
    color: "rgba(0, 0, 0, 1)",
  },
  stepBar: {
    width: "32px",
    height: "3px",
    marginTop: "8px",
    background: "#DADADA",
    borderRadius: '3px',
  },
  headerSlide: {
    fontFamily: "Open Sans",
    fontSize: "36px",
    fontWeight: 600,
    lineHeight: "48px",
    color: "rgba(0, 0, 0, 1)",
    marginTop: "20px",
  },
  headerDescription: {
    fontFamily: "Open Sans",
    fontSize: "16px",
    lineHeight: "24px",
    color: "rgba(51, 51, 51, 0.75)",
    marginTop: "16px",
    marginBottom: "32px",
  },
  button: {
    fontFamily: "Open Sans",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    padding: "6px 24px",
    height: "48px",
  },
  slideIntro: {
    textAlign: "center",
    padding: "0px 80px",
  },
  introContainerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  introTitle: {
    fontFamily: "Open Sans",
    fontSize: '32px',
    fontWeight: 600,
    lineHeight: "50px",
  },
  introContainer: {
    marginTop: "44px",
  },
  introHeader: {
    fontFamily: "Open Sans",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
  },
  introContent: {
    margin: "auto",
    marginTop: "12px",
    maxWidth: "550px",
    fontFamily: "Open Sans",
    fontSize: "16px",
    lineHeight: "24px",
    color: "rgba(51, 51, 51, 0.75)"
  },
  bottomContainer: {
    border: "1px solid #EEEEEE",
    borderRadius: "10px",
    padding: "24px",
    marginTop: "50px"
  },
  bottomHeader: {
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "27px"
  },
  feature: {
    fontFamily: "Open Sans",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
    marginTop: "12px"
  },
  featureIcon: {
    background: "linear-gradient(94.62deg, rgba(38, 213, 237, 0.06) 0%, rgba(38, 187, 237, 0.06) 100%)",
    borderRadius: "10px",
    width: "60px",
    height: "60px",
    padding: "18px",
    margin: "auto"
  },
  featureContainer: {
    maxWidth: "150px",
    marginTop: "24px"
  },
  features: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
  },
  buttonStyle: {
    padding: "8px 24px",
    marginTop: "32px",
    height: "40px",
  },
  partyPopper: {
    position: "absolute",
    top: 0,
    left: 0,
  },
  fireWorks: {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
});